import { combineReducers } from 'redux';

import activation from '../actions/activation';
import overview from '../actions/overview';

const rootReducer = combineReducers({
    activation,
    overview,
});

export type ReducerState = ReturnType<typeof rootReducer>;
export default rootReducer;
